import angular from 'angular';
import uiRouter from 'angular-ui-router';
import checksComponent from './checks.component';

let checksModule = angular.module('app.containers.checks', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('checks', {
      url: '/checks',
      template: '<checks></checks>'
    });
})

.component('checks', checksComponent);

export default checksModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/checks/checks.js
 **/